import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import routes from "../../Routes/routes";

function AppContent({isSidebarOpen,toggle}) {
    const token = JSON.parse(localStorage.getItem('mmt_front_token'));
    // console.log("token",token)
    const idToken = token?.idToken;




  return (
    <Routes>
      {idToken && idToken.length > 0 ?
        routes.map((route, idx) => {
          return (
            route.element && (
              <Route
                key={idx}
                path={route.path}
                exact={route.exact}
                name={route.name}
                element={<route.element isSidebarOpen={isSidebarOpen} toggle={toggle}/>}
              />
            )
          );
        }) :
        <Route
          path="*"
          element={<Navigate to="/login" replace />}
        />
      }

    </Routes>
  );
}

export default AppContent;
